import React, { forwardRef, useRef } from "react";
import makeStyles from '@mui/styles/makeStyles';
//import jsPDF from "jspdf";

//Services
import * as Service from "../../../services/Service.js";
import Constants from "../../../services/Constants";
import swal from "sweetalert";
// materialui table
import MaterialTable from "@material-table/core";
import {
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TablePagination,
  Typography,
} from "@mui/material";

import { useTranslation } from "react-i18next";

import { Button } from "reactstrap";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import * as api from "../../../actions/api";

// react-tabulator
import "react-tabulator/lib/styles.css"; // required styles
import "react-tabulator/lib/css/tabulator.min.css"; // theme
import { ReactTabulator, reactFormatter } from "react-tabulator";

import { DeleteOutline, Edit, ViewList } from "@mui/icons-material";
import encryptionService from "../../../services/encryptionService";

const fileType =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const fileExtension = ".xlsx";

const Products = (props) => {
  const permissionType = props.permissionType;
  //get DispensingLanguage
  const DispensingLanguage = JSON.parse(
    localStorage.getItem("DispensingLanguage")
  );
  const lan = localStorage.getItem("LangCode");
  const menukey = "prescriber";
  const FacilityId = localStorage.getItem("FacilityId");
  const UserInfo = encryptionService.decryptUserInfo();
  const UserName = UserInfo == 0 ? "" : UserInfo[0].name;

  const classes = useStyles();
  const tableRef = useRef();
  const { useState } = React;
  const [selectedRow, setSelectedRow] = useState(null);
  const [productsData, selectProductsData] = useState([]);
  const [productsAllData, selectProductsAllData] = useState([]);
  const [productGroupData, selectProductGroupData] = useState([]);
  const [productGroupFilter, selectProductGroupFilter] = useState("0");
  const [firstLoad, setFirstLoad] = useState(true);
  const [numberRowPerPage, setNumberRowPerPage] = useState(5);
  const [totalRow, setTotalRow] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [query, setQuery] = useState("");
  const [dataItems, setDataItems] = useState([]);
  const { t, i18n } = useTranslation();
  const queryClient = useQueryClient();
  const { isLoading, error, isError, data, refetch } = useQuery(["prescriber"],
    api.getPrescribers,
    {
      onSuccess: (data) => {
        setDataItems(data);
      },
      refetchOnWindowFocus: false,
      refetchOnmount: false,
      refetchOnReconnect: false,
      retry: false,
      staleTime: 0, //1000 * 60 * 60 * 24,
    }
  );
  const { mutate } = useMutation(api.deletePrescriber, {
    onSuccess: (data) => {
      //console.log(data);

      if (data.status == 200) {
        if (FacilityId == data.FacilityId) {
          api
            .getFacilityListNotEqual99ANDSuppliers(
              "PrescriberList",
              data.FacilityId
            )
            .then((response) => {
              localStorage.setItem(
                "PrescriberList",
                JSON.stringify(response.datalist.PrescriberList)
              );
            });
        }

        localStorage.setItem("UserList", JSON.stringify(data.userlist));

        refetch();
        queryClient.getQueriesData("prescriber");

        props.openNoticeModal({
          isOpen: true,
          msg: data.message,
          msgtype: data.success,
        });
      } else {
        props.openNoticeModal({
          isOpen: true,
          msg: data.message,
          msgtype: data.success,
        });
      }
    },
  });

  /* =====Start of Excel Export Code==== */
  const EXCEL_EXPORT_URL = process.env.REACT_APP_API_URL;

  const PrintPDFExcelExportFunction = (reportType) => {
    let finalUrl = EXCEL_EXPORT_URL + "report/print_pdf_excel_server.php";

    window.open(
      finalUrl +
        "?action=getprescriberList" +
        "&reportType=" +
        reportType +
        "&menukey=" +
        menukey +
        "&lan=" +
        localStorage.getItem("LangCode") +
        "&TimeStamp=" +
        Date.now()
    );
  };
  /* =====End of Excel Export Code==== */

  const tableRowDoubleClick = (e, row) => {
    let rowData = row._row.data;
    editProduct(rowData);
  };

  const columns = [
    { title: "Id", field: "id", width: 50, visible: false },
    {
      title: t(DispensingLanguage[lan][menukey]["Sl#"]),
      formatter: "rownum",
      width: 70,
      hozAlign: "center",
      headerSort: false,
      headerHozAlign: "center",
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Last Name"]),
      field: "lastName",
      width: 200,
      headerFilter: true,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["First Name"]),
      field: "firstName",
      width: 200,
      headerFilter: true,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Rx Level"]),
      field: "rxLevel",
      width: 100,
      align: "center",
      headerHozAlign: "center",
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Number"]),
      field: "number",
      width: 200,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Demander"]),
      field: "FacilityName",
      headerFilter: true,
      // width: 250,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["User"]),
      field: "name",
      width: 210,
      headerFilter: true,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Actions"]),
      field: "custom",
      hozAlign: "center",
      width: 100,
      headerSort: false,
      headerHozAlign: "center",
      formatter: reactFormatter(<ActionButton />),
    },
  ];

  const editProduct = (data) => {
    let route = `prescriber/edit/${data.id}`;
    props.history.push(route);
  };

  const deleteProduct = (data) => {
    swal({
      title: t(DispensingLanguage[lan][menukey]["Are you sure?"]),
      text: t(
        DispensingLanguage[lan][menukey][
          "Once deleted, you will not be able to recover this prescriber!"
        ]
      ),
      icon: "warning",
      buttons: [
        t(DispensingLanguage[lan][menukey]["No"]),
        t(DispensingLanguage[lan][menukey]["Yes"]),
      ],
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        mutate(data.id);
      }
    });
  };

  function ActionButton(props: any) {
    const rowData = props.cell._cell.row.data;
    const cellValue = props.cell._cell.value || "Edit | Show";

    if (permissionType)
      return (
        <>
          <ViewList
            onClick={() => {
              editProduct(rowData);
            }}
          />
        </>
      );
    else
      return (
        <>
          <Edit
            onClick={() => {
              editProduct(rowData);
            }}
          />
          <DeleteOutline
            onClick={() => {
              deleteProduct(rowData);
            }}
          />
        </>
      );

    /* return (
      <>
        <Edit
          onClick={() => {
            editProduct(rowData);
          }}
        />
        <DeleteOutline
          onClick={() => {
            deleteProduct(rowData);
          }}
        />
      </>
    ); */
  }

  return (
    <>
      <div className={classes.productPageTitle}>
        <div className="d-flex justify-product mb-2">
          <Grid container>
          <Grid item xs={12} sm={12}>
            <div className="sw_page_heading">
              <div className="sw_heading_title">
                {DispensingLanguage[lan][menukey]["Prescriber"]}
              </div>
              <div className="float-end sw_btn_control">
                <Button
                  disabled={!!props.permissionType}
                  color="info"
                  className="me-2"
                  onClick={() => {
                    props.history.push("/prescriber/add");
                  }}
                >
                  {DispensingLanguage[lan][menukey]["Add Prescriber"]}
                </Button>
                <Button
                  color="info"
                  className="me-2 sw_icons"
                  onClick={() => PrintPDFExcelExportFunction("print")}
                >
                  <i className="fas fa-print"></i>
                </Button>

                <Button
                  color="info"
                  className="me-2 sw_icons"
                  onClick={() => PrintPDFExcelExportFunction("excel")}
                >
                  <i className="far fa-file-excel"></i>
                </Button>
              </div>
            </div>
          </Grid>
          </Grid>
        </div>

        <div>
          <div className="uniqueName">
            <ReactTabulator
              columns={columns}
              data={dataItems}
              layout={"fitColumns"}
              height={500}
              events={{
                rowDblClick: (e, row) => tableRowDoubleClick(e, row),
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Products;

const useStyles = makeStyles({
  productPageTitle: {
    marginTop: "60px",
    color: "white",
    background: "whitesmoke",
    color: "black",
    borderRadius: "10px",
    padding: "1rem",
  },
  tableContainer: { backgroundColor: "whitesmoke", borderRadius: "10px" },
  fullWidth: {
    width: "95%",
  },
  filterDiv: {
    width: "80%",
    display: "flex",
  },
});
